import { forwardRef } from 'react';
import { HeaderGroup } from '@tanstack/react-table';
import { getHeaderWidthStyle } from '../columnSizing/getHeaderWidthStyle';

type ColGroupsProps = {
  cols: HeaderGroup<any>;
};

export const ColGroup = forwardRef<HTMLTableColElement, ColGroupsProps>(
  ({ cols }, ref) => {
    return (
      <colgroup ref={ref}>
        {cols.headers.map((header, idx) => {
          return (
            <col
              key={`col-${header.id}-${idx}`}
              style={getHeaderWidthStyle(header, {
                width: header.column.columnDef.meta?.width,
                minWidth: header.column.columnDef.meta?.minWidth,
                maxWidth: header.column.columnDef.meta?.maxWidth,
              })}
            />
          );
        })}
      </colgroup>
    );
  }
);
